import { Box, BoxProps, ButtonProps, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Dimensions } from 'react-native'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
const ImageLanding = require('../../assets/images/truly-omni-channel.png')
const ImageLandingTab = require('../../assets/images/truly-omni-channel.png')
const ImageLandingMobile = require('../../assets/images/truly-omni-channel.png')

const OmniChannel: FC = () => {
  const { headerSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const themedStyle = styles(viewPortWidth)

  const isMob = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)

  const returnImageStyle = () => {
    if (isMob) {
      return { ...imageStyle.portaitImageStyle }
    } else if (isTab) {
      return { ...imageStyle.portaitTabImageStyle }
    } else {
      return { ...imageStyle.wide }
    }
  }

  const returnImage = () => {
    if (isMob) {
      return ImageLandingMobile
    } else if (isTab) {
      return ImageLandingTab
    } else {
      return ImageLanding
    }
  }

  return (
    <Box {...themedStyle.content} overflowY={'visible'}>
      <Box {...themedStyle.boxLanding}>
        <Box {...themedStyle.titleContainer}>
          <Text
            fontFamily="jiotype-black"
            fontSize={headerSize}
            color={'BLACK_21'}
            lineHeight={isMob ? 32 : isTab ? 38 : 66}>
            {staticStrings.omniChannelTitle}
          </Text>
        </Box>
        <Spacer size={isMob ? 16 : isTab ? 24 : 32} />
        <Box width={isTab ? '90%' : isMob ? '95%' : '70%'}>
          <Text
            color="BLACK_21"
            textAlign="left"
            lineHeight={isMob ? 20 : isTab ? 24 : 30}
            fontSize={isMob ? 14 : isTab ? 14 : 18}
            fontFamily="jiotype-medium"
            opacity={0.9}>
            {staticStrings.omniChSubTitle}
          </Text>
        </Box>
        <Spacer direction="vertical" size={isMob ? 120 : 0} />
      </Box>
      <Box {...themedStyle.imageBox} {...themedStyle.imageBoxFix}>
        <Image resizeMode="contain" source={returnImage()} {...returnImageStyle()} />
      </Box>
    </Box>
  )
}

export default OmniChannel
const imageStyle = {
  portaitImageStyle: {
    height: '100%',
    width: '100%',
    left: -10,
  },
  wide: {
    width: 900,
    height: 900 * 0.72,
    top: 0,
    left: 0,
  },
  portaitTabImageStyle: {
    width: 496,
    height: 600,
  },
}

const styles = (breakpoint: number) => {
  const isMobile = isMobileWidth(breakpoint) //breakpoint < 520
  const isTab = isTabletWidth(breakpoint) //breakpoint < 992
  // const responsivePadding = getPadding(breakpoint)
  return {
    content: {
      display: 'flex',
      flexDirection: isTab ? 'row' : isMobile ? 'column-reverse' : 'row',
      pt: isMobile ? 88 : 0,
    } as BoxProps,
    boxLanding: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignSelf: isMobile || isTab ? 'center' : undefined,
      // minHeight: isMobile ? '70vh' : '90vh',
      width: isMobile ? '100%' : isTab ? '55%' : breakpoint === 1024 ? '65%' : '60%',
      zIndex: 12,
      marginTop: isMobile ? 0 : isTab ? 100 : undefined,
    } as BoxProps,
    button: {
      borderRadius: 8,
      width: isMobile || isTab ? 144 : 192,
      height: isMobile || isTab ? 48 : 56,
      color: colors.HIGHLIGHT as ColorOptions,
    } as ButtonProps,
    imageBox: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      // marginLeft: isMobile ? -120 : undefined,
      minHeight: isTab
        ? breakpoint === 1024
          ? '40vh'
          : '60vh'
        : isMobile
        ? Dimensions.get('window').width * 0.75
        : '50vh',
    } as BoxProps,
    imageBoxFix: {
      paddingLeft: isTab ? 100 : undefined,
      // marginRight: isTab ? 0 : '-16%',
      marginTop: isTab ? 0 : isMobile ? 8 : 10,
    } as BoxProps,
    buttonBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      minHeight: !isMobile ? 120 : undefined,
      marginTop: 24,
    } as BoxProps,
    titleContainer: {
      width: isMobile ? '85%' : isTab ? '80%' : '82%',
    } as BoxProps,
  }
}
